export const colors = {
  // btobPetrolio: {
  //   DEFAULT: "#1B4D5E",
  //   dark: "#033445",
  //   light: "#699AAB",
  // },
  // btobRosa: {
  //   DEFAULT: "#EEC8A4",
  //   dark: "#C5A07C",
  //   light: "#FFDEBE",
  // },
  categories: {
    pubblicaAmministrazione: {
      DEFAULT: "#68B5D5",
      dark: "#287595",
      light: "#8EDBFB",
      text: "#FFFFFF",
    },
    lussoEModa: {
      DEFAULT: "#FF8E7E",
      dark: "#B24233",
      light: "#FFBBB2",
      text: "#FFFFFF",
    },
    projectManagement: {
      DEFAULT: "#00996C",
      dark: "#00654B",
      light: "#45ECC0",
      text: "#FFFFFF",
    },
    arteCulturaSport: {
      DEFAULT: "#812BA8",
      dark: "#55017D",
      light: "#BB67E3",
      text: "#FFFFFF",
    },
    digitalTransformation: {
      DEFAULT: "#FF8F02",
      dark: "#CE7100",
      light: "#FFBC67",
      text: "#FFFFFF",
    },
    marketingComunicazioneDigitalESocialMedia: {
      DEFAULT: "#FFC81C",
      dark: "#E2AA00",
      light: "#FFDE77",
      text: "#090909",
    },
    venditeERetail: {
      DEFAULT: "#FF6B00",
      dark: "#B34B00",
      light: "#FFA666",
      text: "#FFFFFF",
    },
    gestioneDiImpresaExportEInternazionalizzazione: {
      DEFAULT: "#0078AC",
      dark: "#00506B",
      light: "#43C7F4",
      text: "#FFFFFF",
    },
    hrLavoroESviluppoManageriale: {
      DEFAULT: "#00E97D",
      dark: "#00BA64",
      light: "#59FFB2",
      text: "#090909",
    },
    foodBeverageETurismo: {
      DEFAULT: "#941928",
      dark: "#68000D",
      light: "#D75D6C",
      text: "#FFFFFF",
    },
    softSkills: {
      DEFAULT: "#FF5FB1",
      dark: "#B8196A",
      light: "#FF9FD0",
      text: "#FFFFFF",
    },
    dirittoEFisco: {
      DEFAULT: "#FF2C37",
      dark: "#B3000A",
      light: "#FF8087",
      text: "#FFFFFF",
    },
    sanitaPharmaEBiomed: {
      DEFAULT: "#8ED8DD",
      dark: "#6AB3B8",
      light: "#ABF5FA",
      text: "#090909",
    },
    ambienteEnergia: {
      DEFAULT: "#00D0FF",
      dark: "#00A6CC",
      light: "#99ECFF",
      text: "#FFFFFF",
    },
    amministrazioneFinanzaEControllo: {
      DEFAULT: "#0062CF",
      dark: "#003B7C",
      light: "#499FFF",
      text: "#FFFFFF",
    }
  },
  types: {
    mbaPartTime: {
      DEFAULT: "#D3D3D3",
      dark: "#949494",
      light: "#EDEDED",
      text: "#090909",
    },
    mbaFullTime: {
      DEFAULT: "#C7B273",
      dark: "#A79254",
      light: "#EDD99A",
      text: "#090909",
    },
    emba: {
      DEFAULT: "#262626",
      dark: "#000000",
      light: "#7D7D7D",
      text: "#FFFFFF",
    }
  }
}